const childTitleAge = document.querySelectorAll(".child_link-title--age");
const grandchildLinkWrapperAge = document.querySelectorAll(
  ".grandchild_link-wrapper--age"
);

function initializeFirstChild() {
  if (childTitleAge.length === 0) {
    return;
  }

  const firstChild = childTitleAge[0];
  const firstChildIndex = firstChild.getAttribute("data-index");

  firstChild.classList.add("is-active");

  grandchildLinkWrapperAge.forEach((grandChild) => {
    if (grandChild.getAttribute("data-index") === firstChildIndex) {
      grandChild.style.display = "flex";
    } else {
      grandChild.style.display = "none";
    }
  });
}

initializeFirstChild();

childTitleAge.forEach((child) => {
  const childIndex = child.getAttribute("data-index");

  child.addEventListener("click", function () {
    childTitleAge.forEach(c => {
      c.classList.remove('is-active');
    });

    child.classList.add("is-active");

    grandchildLinkWrapperAge.forEach((grandChild) => {
      const grandChildIndex = grandChild.getAttribute("data-index");

      if (childIndex === grandChildIndex) {
        grandChild.style.display = "flex";
      } else {
        grandChild.style.display = "none";
      }
    });
  });
});
